import React                             from 'react';
import { Form, useFormikContext }        from 'formik';
import { withStyles }                    from '@material-ui/styles';
import { Box }                           from '@material-ui/core';
import { TDataTableRow }                 from '@typings/components';
import { IBulkPricingList }              from '@typings/invoiceManagement';
import { IFeeValues }                    from '@typings/accountManagement';
import { Button, DataTable }             from '@components/index';
import { ICheckboxOption }               from '@components/Checkbox/CheckboxFieldGroup';
import { BulkAccountsModal }             from './BulkAccountsModal';
import { DEFAULT_PRICING_TABLE_HEADERS } from '../utils/tableHeaders';

const ActionsWrapper = withStyles({
  root: {
    display   : 'flex',
    flexWrap  : 'wrap',
    marginTop : '30px',
  },
})(Box);

interface IProps {
  rows                    : TDataTableRow[];
  isBulkAccounts          : boolean;
  isEditing               : boolean;
  isLoading               : boolean;
  organizationsOptions    : ICheckboxOption[];
  handleBulkAccountsModal : () => void;
  handleUpdateBulkFees    : (feesValues: IFeeValues[], accountList: IBulkPricingList) => void;
  toggleIsEditing         : () => void;
  toggleIsBulkAccounts    : () => void;
}

export const DefaultPricingForm: React.FC<IProps> = ({
  rows,
  isBulkAccounts,
  isLoading,
  isEditing,
  organizationsOptions,
  handleBulkAccountsModal,
  handleUpdateBulkFees,
  toggleIsEditing,
  toggleIsBulkAccounts,
}) => {
  const { dirty, isValid, isSubmitting, handleReset } = useFormikContext<IFeeValues[]>();

  return (
    <Form>
      <ActionsWrapper>
        <DataTable
          headers   = {DEFAULT_PRICING_TABLE_HEADERS}
          rows      = {rows}
          minwidth  = "367px"
          rowheight = "50px"
        />
      </ActionsWrapper>

      {isEditing ? (
        <Box
          display        = "flex"
          justifyContent = "end"
        >
          <Button
            label   = "Cancel"
            width   = "250px"
            variant = "outlined"
            onClick = {handleReset}
          />

          <Button
            width     = "250px"
            type      = "submit"
            label     = "Save Changes"
            isLoading = {isSubmitting}
            disabled  = {!dirty || !isValid || isLoading}
          />
        </Box>
      ) : (
        <>
          <Button
            variant = "outlined"
            width   = "250px"
            label   = "Apply for all"
            onClick = {handleBulkAccountsModal}
          />
          <Button
            label   = "Edit Prices"
            width   = "250px"
            onClick = {() => toggleIsEditing()}
          />
        </>
      )}

      <BulkAccountsModal
        isOpen               = {isBulkAccounts}
        isLoading            = {false}
        organizationsOptions = {organizationsOptions}
        handleUpdateBulkFees = {handleUpdateBulkFees}
        toggleModal          = {toggleIsBulkAccounts}
      />
    </Form>
  );
};
